export default "__VITE_ASSET__BadD3$By__"